import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import moment from 'moment';
import servicesPlugin, { injectServices } from './plugins/services';

const plugins = [
	// STORE PERSIST
	createPersistedState({
		key: 'auth',
		paths: [
			'auth',
		],
		storage: window.localStorage,
	}),
	createPersistedState({
		key: 'settings',
		paths: [
			'settings',
		],
		storage: window.localStorage,
	}),
	createPersistedState({
		key: 'query',
		paths: [
			'query',
		],
		storage: window.localStorage,
	}),
	// SESSION CACHE
	createPersistedState({
		key: 'data',
		paths: [
			'data',
		],
		filter: mutation => mutation.type !== 'SET_DATA_LOADING',
		storage: window.sessionStorage,
	}),
	createPersistedState({
		key: 'flags',
		paths: [
			'flags',
		],
		storage: window.sessionStorage,
	}),
	// TTL CACHE
	createPersistedState({
		key: 'forms',
		paths: [
			'forms',
		],
		storage: {
			getItem: (key) => {
				const now = moment().unix();
				const value = localStorage.getItem(key) || null;

				if (value && now >= JSON.parse(value).forms.expiration) {
					localStorage.removeItem(key);
					return null;
				}

				return value;
			},
			setItem: (key, value) => {
				localStorage.setItem(key, value);
			},
			removeItem: (key) => {
				localStorage.removeItem(key);
			},
		},
	}),
	createPersistedState({
		key: 'stats',
		paths: [
			'stats',
		],
		storage: {
			getItem: (key) => {
				const now = moment().unix();
				const value = sessionStorage.getItem(key) || null;

				if (value && now >= JSON.parse(value).stats.expiration) {
					sessionStorage.removeItem(key);
					return null;
				}

				return value;
			},
			setItem: (key, value) => {
				sessionStorage.setItem(key, value);
			},
			removeItem: (key) => {
				sessionStorage.removeItem(key);
			},
		},
	}),
];

// LOAD MODULES
const modules = {};
const files = require.context('./modules/', false, /\.js$/);
files.keys().forEach((key) => {
	modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default;
});


const Store = createStore({
	modules,
	plugins: [...plugins, servicesPlugin],
	strict: process.env.NODE_ENV !== 'production',
});

export { injectServices };
export default Store;
